<template>
    <div class="float-video">
        <v-sheet
            v-if="show"
            elevation="10"
            rounded
        >
            <v-btn
                style="z-index: 2;"
                absolute
                right
                icon
                top
                @click="show = false"
            >
                <i
                    class="v-icon notranslate mdi mdi-close theme--dark"
                />
            </v-btn>
            <video autoplay>
                <source
                    :src="src"
                    type="video/mp4"
                >
            </video>
        </v-sheet>
    </div>
</template>

<script>
    export default {
        props: {
            src: {
                type: String,
                default: '',
            },
        },
        data: () => ({
            show: false,
        }),
        watch: {
            src: {
                immediate: true,
                handler(val) {
                    if (val) this.show = true;
                },
            },
        },
    };
</script>

<style lang="scss">
.float-video {
    position: fixed;
    bottom: 1em;
    right: 1em;
    z-index: 100;

    & > div {
        position: relative;
    }

    video {
        width: 30em;
        max-width: 90vw;
    }
}
</style>
